import {
  LayoutDashboard, Users, Package,
  UserCog, Wrench, Settings, Wallet, CreditCard, HandCoins,
  Building2,
  Sun, Moon, LogOut, ChevronLeft, ChevronRight,
} from "lucide-react";

export const TABS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "departments", label: "Departments", icon: Building2 },
  { id: "clients", label: "Clients", icon: Users },
  { id: "paymentsV2", label: "Sales", icon: CreditCard },
  { id: "transactions", label: "Expenses", icon: Wallet },
  { id: "offers", label: "Offers", icon: Package },
  { id: "team", label: "Team", icon: UserCog },
  { id: "tools", label: "Tools", icon: Wrench },
  { id: "dividends", label: "Dividends", icon: HandCoins },
  { id: "settings", label: "Settings", icon: Settings },
];

export default function Sidebar({ activeTab, onChange, darkMode, onToggleDark, user, onSignOut, collapsed, onToggleCollapsed }) {
  const widthCls = collapsed ? "w-[60px]" : "w-[220px]";
  return (
    <aside className={`hidden md:flex md:flex-col ${widthCls} shrink-0 bg-white dark:bg-[var(--bg-surface)] border-r border-gray-100 dark:border-[var(--border-soft)] sticky top-0 h-screen transition-[width] duration-150`}>
      <div className={`pt-5 pb-4 flex items-center ${collapsed ? "justify-center" : "px-5 gap-2.5"}`}>
        <div className="w-8 h-8 rounded-lg bg-brand-ink flex items-center justify-center shrink-0">
          <span className="text-white font-display font-bold text-sm">U</span>
        </div>
        {!collapsed && (
          <div className="min-w-0">
            <div className="font-display font-semibold text-brand-ink dark:text-[var(--text-primary)] leading-tight text-sm">UniCamel</div>
            <div className="text-[10px] uppercase tracking-wider text-brand-slate leading-tight">Agency Dashboard</div>
          </div>
        )}
      </div>

      <nav className={`flex-1 ${collapsed ? "px-2" : "px-3"} pt-3 space-y-0.5 overflow-y-auto`}>
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              title={collapsed ? tab.label : undefined}
              className={`w-full flex items-center ${collapsed ? "justify-center px-0 py-2.5" : "gap-2.5 px-3 py-2"} rounded-lg text-sm font-medium transition-colors ${
                active
                  ? "bg-brand-ink text-white"
                  : "text-brand-slate hover:bg-gray-50 dark:hover:bg-[var(--bg-soft)] hover:text-brand-ink dark:hover:text-[var(--text-primary)]"
              }`}
            >
              <Icon size={16} />
              {!collapsed && tab.label}
            </button>
          );
        })}
      </nav>

      <div className={`${collapsed ? "p-2" : "p-3"} border-t border-gray-100 dark:border-[var(--border-soft)] space-y-0.5`}>
        {user && !collapsed && (
          <div className="px-3 py-2 text-[10px] uppercase tracking-wider text-brand-slate truncate" title={user.email}>
            {user.email}
          </div>
        )}
        <button
          onClick={onToggleDark}
          title={collapsed ? (darkMode ? "Light mode" : "Dark mode") : undefined}
          className={`w-full flex items-center ${collapsed ? "justify-center px-0 py-2.5" : "gap-2.5 px-3 py-2"} rounded-lg text-sm font-medium text-brand-slate hover:bg-gray-50 dark:hover:bg-[var(--bg-soft)]`}
        >
          {darkMode ? <Sun size={16} /> : <Moon size={16} />}
          {!collapsed && (darkMode ? "Light mode" : "Dark mode")}
        </button>
        {onSignOut && (
          <button
            onClick={onSignOut}
            title={collapsed ? "Sign out" : undefined}
            className={`w-full flex items-center ${collapsed ? "justify-center px-0 py-2.5" : "gap-2.5 px-3 py-2"} rounded-lg text-sm font-medium text-brand-slate hover:bg-red-50 hover:text-red-600`}
          >
            <LogOut size={16} />
            {!collapsed && "Sign out"}
          </button>
        )}
        {onToggleCollapsed && (
          <button
            onClick={onToggleCollapsed}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            className={`w-full flex items-center ${collapsed ? "justify-center px-0 py-2.5" : "gap-2.5 px-3 py-2"} rounded-lg text-sm font-medium text-brand-slate hover:bg-gray-50 dark:hover:bg-[var(--bg-soft)]`}
          >
            {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
            {!collapsed && "Collapse"}
          </button>
        )}
      </div>
    </aside>
  );
}
